import ColorsStyles from '@Styles/colors.scss';
import InsightsIcon from '@mui/icons-material/Insights';
import { SvgIcon, Tooltip } from '@mui/material';
import React from 'react';
import { IconButton } from '@Components/IconButton';

export const Dashboards = () => {
    const handleOpenPreset = () => {
        // const url = `${process.env.PRESET_URL}/dashboard/list/?pageIndex=0&sortColumn=changed_on_delta_humanized&sortOrder=desc&viewMode=table`;
        const url = process.env.LOOKER_LIST_URL;
        window.open(url, '_blank');
    };

    return (
        <Tooltip title="Dashboards">
            <div
                style={{
                    border: `1px solid ${ColorsStyles.ikeGradient11}`,
                    marginRight: '18px',
                }}
            >
                <IconButton
                    onClick={handleOpenPreset}
                    icon={
                        <SvgIcon inheritViewBox>
                            <InsightsIcon fontSize="small" />
                        </SvgIcon>
                    }
                />
            </div>
        </Tooltip>
    );
};
